import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loader-ring"></div>
      <div className="loader-text">Loading...</div>
    </div>
  );
};

export default Loading;
